import axios from 'axios'
import store from '../index'
const request = axios.create({
  baseURL: process.env.VUE_APP_URL,
})

axios.interceptors.request.use(
  (config) => {
    // Get token and add it to header "Authorization"
    const token = localStorage.getItem('access_token')
    if (token) {
      config.headers.Authorization = 'Bearer ' + token
    }
    return config
  },
  (error) => Promise.reject(error),
)

let isAlreadyFetchingAccessToken = false
let subscribers = []

function onAccessTokenFetched (accessToken) {
  subscribers = subscribers.filter(callback => callback(accessToken))
}

function addSubscriber (callback) {
  subscribers.push(callback)
}

axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  const { config, response: { status } } = error
  const originalRequest = config

  if (originalRequest.url === '/api/refresh-token') {
    store.commit('toast/show', { tipo: 'error', messages: ['La sesión ha expirado'] })
    store.commit('ResetLoader', null, { root: true })
    store.dispatch('logout', { root: true })
  }
  if (status === 401) {
    // console.log('estatus 401')
    // console.log('valor de fetching: ' + isAlreadyFetchingAccessToken)
    if (!isAlreadyFetchingAccessToken) {
      // console.log('pide token')
      isAlreadyFetchingAccessToken = true
      store.dispatch('fetchAccessToken', { root: true }).then((accessToken) => {
        isAlreadyFetchingAccessToken = false
        onAccessTokenFetched(accessToken)
      })
    }

    const retryOriginalRequest = new Promise((resolve) => {
      addSubscriber(accessToken => {
        originalRequest.headers.Authorization = 'Bearer ' + accessToken
        resolve(axios(originalRequest))
      })
    })
    return retryOriginalRequest
  }
  return Promise.reject(error)
})

export default request
